<div class="throbber">
    <span class="throbber__item1"></span>
    <span class="throbber__item2"></span>
    <span class="throbber__item3"></span>
    <span class="throbber__item4"></span>
</div>
